export const getClassName = (
  dateObj?: Date,
  checkin?: Date | null,
  checkout?: Date | null,
): string => {
  if (!dateObj) {
    return '';
  }

  if (
    checkin &&
    dateObj.getMonth() === checkin.getMonth() &&
    dateObj.getDate() === checkin.getDate() &&
    dateObj.getFullYear() === checkin.getFullYear()
  ) {
    return 'leftactive';
  }

  if (
    checkout &&
    dateObj.getMonth() === checkout.getMonth() &&
    dateObj.getDate() === checkout.getDate() &&
    dateObj.getFullYear() === checkout.getFullYear()
  ) {
    return 'rightactive';
  }

  if (
    checkin &&
    checkout &&
    dateObj.getTime() > checkin.getTime() &&
    dateObj.getTime() < checkout.getTime()
  ) {
    return 'partial';
  }

  return '';
};

export function getMapFromArrayOfDates(datesArrayOfObejcts) {
  if (!datesArrayOfObejcts) return {};

  const monthMap = {};
  datesArrayOfObejcts.forEach(dateObject => {
    for (let date in dateObject) {
      try {
        const holidayMap = dateObject[date] || {};
        const name = holidayMap['name'];
        const dateIndex = Number.parseInt(date);
        monthMap[dateIndex] = name;
      } catch (err) {
        console.log(err);
      }
    }
  });
  return monthMap;
}

export const CalendarModes = {
  SELECTING_CHECKIN: 1,
  SELECTING_CHECKOUT: 2,
};
